var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoreSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00732 2.41211H4.28109C3.25211 2.41211 2.41797 3.24625 2.41797 4.27523V8.00146C2.41797 9.03043 3.25211 9.86457 4.28109 9.86457H8.00732C9.03629 9.86457 9.87043 9.03043 9.87043 8.00146V4.27523C9.87043 3.24625 9.03629 2.41211 8.00732 2.41211Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7007 2.41211H12.9744C11.9455 2.41211 11.1113 3.24625 11.1113 4.27523V8.00146C11.1113 9.03043 11.9455 9.86457 12.9744 9.86457H16.7007C17.7296 9.86457 18.5638 9.03043 18.5638 8.00146V4.27523C18.5638 3.24625 17.7296 2.41211 16.7007 2.41211Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00732 11.1064H4.28109C3.25211 11.1064 2.41797 11.9406 2.41797 12.9696V16.6958C2.41797 17.7248 3.25211 18.5589 4.28109 18.5589H8.00732C9.03629 18.5589 9.87043 17.7248 9.87043 16.6958V12.9696C9.87043 11.9406 9.03629 11.1064 8.00732 11.1064Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8376 18.5589C16.8955 18.5589 18.5638 16.8906 18.5638 14.8327C18.5638 12.7747 16.8955 11.1064 14.8376 11.1064C12.7796 11.1064 11.1113 12.7747 11.1113 14.8327C11.1113 16.8906 12.7796 18.5589 14.8376 18.5589Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreSquare);
export default __webpack_public_path__ + "static/media/more-square.0d1f81a1b9569a7e2a765e1609547cd8.svg";
export { ForwardRef as ReactComponent };